import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Map from 'react-map-gl'
import get from 'lodash/get'

import withConfig from '../../hoc/withConfig'

import 'mapbox-gl/dist/mapbox-gl.css'

const DEFAULT_MAP_STYLE = 'mapbox://styles/mapbox/streets-v12?optimize=true'

// Map reference https://visgl.github.io/react-map-gl/docs/api-reference/map
const MapContainer = (props) => {
  const {
    latitude,
    longitude,
    zoom,
    style,
    mapStyle,
    maxZoom,
    minZoom,
    attributionControl,
    children,
    onClick,
    onMove,
    onMapLoad,
    config,
    ...otherProps
  } = props

  const mapRef = useRef()

  const mapboxAccessToken = get(config, 'mapbox.mapboxAccessToken')

  return (
    <section className='vs-map-container'>
      <Map
        mapboxAccessToken={mapboxAccessToken}
        latitude={latitude}
        longitude={longitude}
        zoom={zoom}
        maxZoom={maxZoom}
        minZoom={minZoom}
        attributionControl={attributionControl}
        style={style}
        ref={mapRef}
        mapStyle={mapStyle || DEFAULT_MAP_STYLE} // ?optimize=true ie removes unused features
        onMove={onMove}
        onLoad={() => onMapLoad(mapRef)}
        onClick={() => onClick()}
        {...otherProps}
      >
        {children}
      </Map>
    </section>
  )
}

MapContainer.propTypes = {
  /**
   * Geolocation coordinate latitude
   */
  latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   *  Geolocation coordinate longitude
   */
  longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The initial zoom level
   */
  zoom: PropTypes.number
}

MapContainer.defaultProps = {
  // Nigeria's geoloaction
  latitude: 9.59396,
  longitude: 8.105306,

  style: {width: '100%', height: 500},
  zoom: 5
}

export default withConfig(MapContainer)
